import { Injectable, EventEmitter } from '@angular/core';
//import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import {HttpClient,HttpHeaders, HttpParams} from '@angular/common/http'
// import { Headers, Http, RequestOptions } from '@angular/http'
//import { Headers, Http, RequestOptions } from '@angular/http'
import { Observable, pipe, throwError } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { BehaviorSubject } from 'rxjs';
import { UserDetail } from '../classes/userDetails';
import { map, filter, catchError, mergeMap,finalize } from 'rxjs/operators';
import { AuthService } from './Auth/auth.service';
import { analyzeFileForInjectables } from '@angular/compiler';

@Injectable({
    providedIn: 'root'
  })

export class DataContextService {

    public static HomeFacilityId: string;

    public static LoggedInUserId: Number;

    public static facility_date: any;

    public static CONFIG_URL: string = '';

    public static REFRESH_TIMEOUT: number;

    public static DataReplicationLatencySec: string;

    public static BASE_URL: string = '/services/api/';

    public static ROWS_PER_PAGE: number;
    public static RECOMMENDATION_LIST_PAGE_SIZE: number;
    public static HotelingAvatarUrl: string;
    public static ToasterStayTime: number;

    public static Typedata_arr: Array<any>;
    public static MenuList_arr: Array<any>;
    public static EmpLev_arr: Array<Object>;
    public static Status_arr: Array<Object>;
    //public static ReservationStatus_arr: Array<any>;
    public static EventsInfo_arr: Array<any>;
    public static SetupType_arr: Array<any>;
    public static MealOption_Types: Array<any>;
    public static EventsInfoFAS_arr: Array<any>;
    public static CateringOrder_Type: Array<any>;
    public static Catering_Status: Array<any>;

    public static NonPeopleProfileTitle: string;
    //public static EventsInfoMeetingRequest: Array<EventType>;
    public static RequestType_arr: Array<any>;
    public static MeetingWaitListStatusTypes_arr: Array<any>
    public static ServiceOrderFilter_arr: Array<any>;

    private static navchange: EventEmitter<number> = new EventEmitter();

    private static refreshEve: EventEmitter<boolean> = new EventEmitter();

    private static resetAdvancedGrid: EventEmitter<boolean> = new EventEmitter();

    private static hideDropDownsEve: EventEmitter<boolean> = new EventEmitter();

    private static setHomefacilityId: EventEmitter<boolean> = new EventEmitter();

    private static reloadFASListView: EventEmitter<boolean> = new EventEmitter();

    private static advancedSearchError: EventEmitter<any> = new EventEmitter();
    //private static onReservationCompletion: EventEmitter<any> = new EventEmitter();
    private static fasSpaceData: EventEmitter<any> = new EventEmitter();

    private static showFASListView: EventEmitter<any> = new EventEmitter();

    private static getRecommendationsFetch: EventEmitter<any> = new EventEmitter();

    private static includeNonAvailableSpaces: EventEmitter<any> = new EventEmitter();

    private static facilityChange: EventEmitter<any> = new EventEmitter();

    public static isBrowserRefresh = true;

    public static checkinData: any;

    public static releaseData: any;

    public static userModel: any;

    public static CanClientConfirmWaitList: boolean = false;

    public static DPNProfilePicToken: string;
    private static RequestCounter: number = 0;
    private static storage: {} = {};

    private headerFiltersData: any = undefined;
    public static ImageBody: string;

    private static partialAvailable: EventEmitter<any> = new EventEmitter<any>();

    constructor(private _http: HttpClient, 
        public spinner: SpinnerService, 
        private http: HttpClient,
        private authService: AuthService) {

    }

    static emitPartialAvailableEmitter(spaceData: any) {
        this.partialAvailable.emit(spaceData);
    }
    static getPartialAvailableEmitter() {
        return this.partialAvailable;
    }
    static emitNavChangeEvent(isShowerror: number) {
        this.navchange.emit(isShowerror);
    }
    static getNavChangeEmitter() {
        return this.navchange;
    }

    static emitFASListViewEvent() {
        this.reloadFASListView.emit();
    }
    static getFASListViewEvent() {
        return this.reloadFASListView;
    }
    static emitShowFASListViewEvent() {
        this.showFASListView.emit({ 'view': 'List', 'spaceData': false });
    }
    static getShowFASListViewEvent() {
        return this.showFASListView;
    }
    static setIncludeNonAvailableSpaces() {
        this.includeNonAvailableSpaces.emit();
    }
    static getIncludeNonAvailableSpaces() {
        return this.includeNonAvailableSpaces;
    }

    static getAdvancedSearchError() {
        return this.advancedSearchError;
    }

    static setAdvancedSearchError(event: any) {
        this.advancedSearchError.emit(event);
    }
    static emitFASSpaceData(spaceDataWithFloorDetails: any) {
        this.fasSpaceData.emit(spaceDataWithFloorDetails);
    }

    static getFASSpaceData() {
        return this.fasSpaceData;
    }
    static getInfoBasedOnFullName(fullName: string): string {
        let userdetails = this.getUserInfo(fullName);
        let usericonTitle = this.getUserIcon(userdetails);
        return usericonTitle;
    }
    static getUserInfo(fullName: string): UserDetail {
        let userDetail = new UserDetail();
        let splittedStrings = fullName.split(/[ ,]+/);
        
        userDetail.FirstName = splittedStrings[0].trim();
        if (!(splittedStrings.indexOf('Guest') > -1))
            if (splittedStrings.length > 1) {
                userDetail.LastName = splittedStrings[1].trim();
            }
        return userDetail;
    }
    static getUserIcon(res: UserDetail): string {
        let title = "";
        if (res.FirstName) {
            title += res.FirstName.charAt(0);
        }
        if (res.LastName) {
            title += res.LastName.charAt(0);
        }
        //if (res.MiddleName) {
        //    title += res.MiddleName.charAt(0);
        //}
        return title;
    }

    static setRecommendationFetchEvent({ getUnavailable: boolean, floorId: number }) {
        let paramObj = { getUnavailable: boolean, floorId: number }
        this.getRecommendationsFetch.emit(paramObj);
    }
    static getRecommendationFetchEvent() {
        return this.getRecommendationsFetch;
    }

    static emitSetHomeFacilityId(isHomefacility: boolean) {
        this.setHomefacilityId.emit(isHomefacility);
    }
    static getHomeFacilityId() {
        return this.setHomefacilityId;
    }

    static refreshTriggerEvent(isrefresh: boolean) {
        this.refreshEve.emit(isrefresh);
    }

    static getRefreshTriggerEvent() {
        return this.refreshEve;
    }

    static hideDropDownTriggerEvent(isHide: boolean) {
        this.hideDropDownsEve.emit(isHide);
    }

    static getHideDropDownTriggerEvent() {
        return this.hideDropDownsEve;
    }

    static resetAdvancedGridEvent(value) {
        this.resetAdvancedGrid.emit(value);
    }

    static getResetAdvancedGridEvent() {
        return this.resetAdvancedGrid;
    }

    setData(data: any) {
        this.headerFiltersData = data;
    }

    getHeaderData(): any {
        return this.headerFiltersData;
    }


    static facilityChangeEmitter(event) {
        this.facilityChange.emit(event);
    }

    static getfacilityChangeEvent() {
        return this.facilityChange;

    }

    static arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    public static setDataToImageBody(data) {
        return DataContextService.ImageBody = data._body;
    }

    // postData(_dataUrl: string, data: Object, setHeader?: boolean, showGlobalSpinner: boolean = true) {
        
    //     if (DataContextService.RequestCounter == 0 && showGlobalSpinner) {
    //         this.spinner.start();
    //     }
        
    //     let bodyString = JSON.stringify(data);

    //     if (showGlobalSpinner) {
    //         DataContextService.RequestCounter = DataContextService.RequestCounter + 1;
    //     }

    //     let headers = new HttpHeaders();
    //     this.setHeaderTypeAsJson(headers);
    //     if (setHeader === true) {
    //         return this._http.post(_dataUrl, bodyString, { headers: headers })            
    //             .pipe(map((response: Response) => response.json()),                
    //             catchError(this.handleError),
    //             finalize(() => {
    //                 // decrement request counter by 1
    //                 if (showGlobalSpinner) {
    //                     DataContextService.RequestCounter = DataContextService.RequestCounter - 1;
    //                     if (DataContextService.RequestCounter == 0) {
    //                         this.spinner.stop();
    //                     }
    //                 }
                    
    //             }));
    //     }
    //     else {
    //         return this._http.post(_dataUrl, bodyString, {
    //             headers: headers
    //         })
    //             .pipe(map((response: Response) => response.json()),
    //             catchError(this.handleError),
    //             finalize(() => {
    //                 // decrement request counter by 1
    //                 if (showGlobalSpinner) {
    //                     DataContextService.RequestCounter = DataContextService.RequestCounter - 1;
    //                     if (DataContextService.RequestCounter == 0) {
    //                         this.spinner.stop();
    //                     }
    //                 }
    //             }));
    //     }
    // }


    // postDataValues(_dataUrl: string, data: Object, setHeader?: boolean) {

    //     let bodyString = JSON.stringify(data);


    //     let headers = new HttpHeaders();       
        
    //     this.setHeaderTypeAsJson(headers);
    //     if (setHeader === true) {
    //         return this._http.post(_dataUrl, bodyString, { headers: headers })
            
    //             .pipe(map((response: Response) => response.json()),
    //             catchError(this.handleError),
    //             finalize(() => {

    //             }));              
    //     }
    //     else {
    //         return this._http.post(_dataUrl, bodyString, {
    //             headers: headers
    //         })
    //             .pipe(map((response: Response) => response.json()),
    //             catchError(this.handleError),
    //             finalize(() => {
    //                 if (DataContextService.RequestCounter == 0) {

    //                 }
    //             }));
    //     }
       
    // }

   

    postDatawithValues<T>(_dataUrl: string, data: Object) : Observable<T> {

        let bodyString = JSON.stringify(data);
        
            return this._http.post(_dataUrl, data, { headers: <HttpHeaders> this.authService.GetHttpHeader()  })
                
                //.pipe(map((response: Response) => <T>response.json()),
                .pipe(map((response: T ) => <T>response ),
                catchError(this.handleError),
                finalize(() => {

                }));  
              
                
       
    }

    postDatawithValuesForDel<T>(_dataUrl: string) : Observable<T> {
        
            return this._http.post(_dataUrl, { headers: <HttpHeaders> this.authService.GetHttpHeader()  })
                //.pipe(map((response: Response) => <T>response.json()),
                .pipe(map((response: T ) => <T>response ),
                catchError(this.handleError),
                finalize(() => {

                }));  
              
                
       
    }

    get<T>(_dataUrl: string) : Observable<T> {                
        return this._http.get(_dataUrl, { headers: <HttpHeaders> this.authService.GetHttpHeader()  })                
            //.pipe(map((response: Response) => <T>response.json()),
            .pipe(map((response: T ) => <T>response ),
            catchError(this.handleError),
            finalize(() => {

            }));                         
    }
    getImage(_dataUrl: string, token : string) : Observable<any> {         
        let imageheaders = new HttpHeaders({
            'Content-Type': 'image/jpeg',
            'Authorization': `Bearer ${token}`,
      
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
            'Access-Control-Allow-Headers': 'Content-Type',
          });
          try{
            return this._http.get(_dataUrl, { responseType: 'blob', headers: <HttpHeaders> imageheaders  })
            .pipe(map((res : any)=> {
                console.log(res);
                return res;
            }));  

          }  catch(e){
            console.log(e);
            }

        
    }



    postDatawithValuesForExport(_dataUrl: string, data: Object):Observable<any> {
        
        let tokenNew = localStorage.getItem('authToken');    
        let headers = new HttpHeaders({
            'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE',
            'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
            'Content-Type' : 'application/json', 
            'responseType' : 'ResponseContentType.Blob',
            'Authorization' : `Bearer ${tokenNew}`
        });
    
        return this.http.post(_dataUrl, data, {headers: <HttpHeaders> headers})
            .pipe(map((response) => {
            return response;
            }),
            catchError(this.ErrorHandler),
            finalize(()=>{}));
        }

    private ErrorHandler(error: any): Promise<any> {
        return Promise.reject(error.messgae || error);
        }

    postOfficeValues<T>(_dataUrl: string, data: Object) : Observable<T> {

        let bodyString = JSON.stringify(data);


        let headers = new HttpHeaders(); 
        // headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');      
      
        headers = <HttpHeaders> this.authService.GetHttpHeader();  
        
            return this._http.post(_dataUrl, data, { headers: headers })
                
                //.pipe(map((response: Response) => <T>response.json()),
                .pipe(map((response: T) => <T>response),
                catchError(this.handleError),
                finalize(() => {

                }));                              
       
    }

    GetwithValues<T>(_dataUrl: string, data: Object, param : HttpParams) : Observable<T> {

        let bodyString = JSON.stringify(data);


        let headers = new HttpHeaders(); 
        // headers.append('Content-Type', 'application/json');
        // headers.append('Access-Control-Allow-Origin', '*');
        // headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
        // headers.append('Access-Control-Allow-Headers', 'Content-Type');      
        headers = <HttpHeaders> this.authService.GetHttpHeader();  
        
        
            return this._http.get(_dataUrl, { params:param, headers: headers })
                
                //.pipe(map((response: Response) => <T>response.json()),
                .pipe(map((response: T) => <T>response),
                catchError(this.handleError),
                finalize(() => {

                }));                              
       
    }

    // patchData(_dataUrl: string, data: Object, setHeader?: boolean, showGlobalSpinner: boolean = true) {
    //     if (DataContextService.RequestCounter == 0 && showGlobalSpinner) {
    //         this.spinner.start();
    //     }
    //     let bodyString = JSON.stringify(data);

    //     if (showGlobalSpinner) {
    //         DataContextService.RequestCounter = DataContextService.RequestCounter + 1;
    //     }

    //     let headers = new HttpHeaders();
    //     if (setHeader === true) {
    //         this.setHeaderTypeAsJson(headers);
    //         console.log(headers)
    //         return this._http.patch(_dataUrl, bodyString, { headers: headers })
    //             .pipe(map((response: Response) => response.json()),
    //             catchError(this.handleError),
    //             finalize(() => {
    //                 // decrement request counter by 1
    //                 if (showGlobalSpinner) {
    //                     DataContextService.RequestCounter = DataContextService.RequestCounter - 1;
    //                     if (DataContextService.RequestCounter == 0) {
    //                         this.spinner.stop();
    //                     }
    //                 }
    //             }));
    //     }
    //     else {
    //         return this._http.patch(_dataUrl, bodyString)
    //             .pipe(map((response: Response) => response.json()),
    //             catchError(this.handleError),
    //             finalize(() => {
    //                 // decrement request counter by 1
    //                 if (showGlobalSpinner) {
    //                     DataContextService.RequestCounter = DataContextService.RequestCounter - 1;
    //                     if (DataContextService.RequestCounter == 0) {
    //                         this.spinner.stop();
    //                     }
    //                 }
    //             }));
    //     }
    // }

    // deleteData(_dataUrl: string, showGlobalSpinner: boolean = true) {
    //     if (DataContextService.RequestCounter == 0 && showGlobalSpinner) {
    //         this.spinner.start();
    //     }
    //     if (showGlobalSpinner) {
    //         DataContextService.RequestCounter = DataContextService.RequestCounter + 1;
    //     }

    //     let headers = new HttpHeaders();
    //     this.setHeaderTypeAsJson(headers);

    //     return this._http.delete(_dataUrl, { headers: headers })
    //         .pipe(map((response: Response) => response.json()),
    //         catchError(this.handleError),
    //         finalize(() => {
    //             // decrement request counter by 1
    //             if (showGlobalSpinner) {
    //                 DataContextService.RequestCounter = DataContextService.RequestCounter - 1;
    //                 if (DataContextService.RequestCounter == 0) {
    //                     this.spinner.stop();
    //                 }
    //             }
    //         }));
    // }

    // setHeaderTypeAsJson(headers: HttpHeaders) {
    //     //headers.append('content-type', 'application/json');
    //     headers = this.setoAuthHeaders(headers);
    //     return headers;
    // }

    // setoAuthHeaders(headers: HttpHeaders): HttpHeaders {
    //     //this.checkTokenStatus();
    //     //headers.append("Authorization", window["userDataToken"]);
    //     headers.append('Content-Type', 'application/json');
    //     headers.append('Access-Control-Allow-Origin', '*');
    //     headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
    //     headers.append('Access-Control-Allow-Headers', 'Content-Type');
    //     return headers;
    // }



    // getParsedUserToken() {
    //     return this.parseJwt(window["userDataToken"]);
    // }

    // parseJwt(token) {
    //     var base64Url = token.split('.')[1];
    //     var base64 = decodeURIComponent(atob(base64Url).split('').map(function (c) {
    //         return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    //     }).join(''));

    //     return JSON.parse(base64);
    // };

    // cacheData(key: string, value: any) {
    //     if (key) {
    //         DataContextService.storage[key] = value;
    //     }
    // }

    // getCachedData(key: string) {
    //     var result;
    //     if (key) {
    //         result = DataContextService.storage[key];
    //     }
    //     return result;
    // }

    // clearCachedData(key: string) {
    //     if (key) {
    //         DataContextService.storage[key] = null;
    //     }
    // }

    private handleError(error: Response) {
        console.error(error); if (error.status == 403)
            DataContextService.emitNavChangeEvent(1);
        else if ((error.status == 500) || (error.status == 400))
            DataContextService.emitNavChangeEvent(2);
        else if ((error.status == 302) || (error.status == 401))
            DataContextService.emitNavChangeEvent(3);

        //return Observable.throw(error.json().error || 'Server error');
        //return Observable.throw(error);
        return throwError(error);
    }
}
